import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';

const useStyles = makeStyles((theme) => ({
    dialog: {},
    dialogPaper: {
        borderRadius: '10px',
        minWidth: '420px',
        maxWidth: '420px',
        padding: '24px',
        margin: '32px',
        '@media (max-width: 600px)': {
            minWidth: 'calc(100vw - 16px)',
            maxWidth: 'calc(100vw - 16px)',
            width: 'calc(100vw - 16px)',
            margin: '8px',
            padding: '20px',
            borderRadius: '10px',
        }
    },
    content: {
        padding: '0 !important',
    },
    title: {
        ...designTokens.typography.h2,
        marginBottom: designTokens.spacing.md,
        color: designTokens.colors.text.primary,
    },
    text: {
        ...designTokens.typography.body,
        color: designTokens.colors.text.secondary,
        marginBottom: designTokens.spacing.xl,
    },
    actions: {
        display: 'flex',
        gap: designTokens.spacing.sm,
        justifyContent: 'flex-end',
        '@media (max-width: 600px)': {
            flexDirection: 'column-reverse',
            '& > button': {
                width: '100%',
            }
        }
    }
}));

const LogoutDialog = ({
    open,
    onClose,
    onConfirm,
}) => {
    const classes = useStyles();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={classes.dialog}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogContent className={classes.content}>
                <div className={classes.title}>Вихід</div>
                <div className={classes.text}>Ви впевнені, що хочете вийти?</div>

                <div className={classes.actions}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        size="small"
                    >
                        Ні
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleConfirm}
                        size="small"
                    >
                        Так
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default LogoutDialog;
